import { NO_SYSTEM_VALUES } from './systemValueTerms'

/**
 * Historia 176 — CU5, T7 (S122, RN14c). The interpolation markers (`{{name}}`) of an i18n key,
 * computed by Jupiter from the KEY ITSELF — never from Sun's error response
 * (`TERM_PLACEHOLDERS_MISMATCH` carries no extra field, `03-dominio.md` §3). Appearance order,
 * deduplicated, so "{{count}} of {{total}} parts" always shows "{{count}}, {{total}}", never the
 * reverse and never twice.
 *
 * @param {string} key The i18n key
 * @returns {string[]} Every distinct `{{marker}}` found in the key, in the order it first appears
 */
export const placeholdersOf = (key) => {
  // CD-17: spaces inside the braces are allowed; the marker is reported in its canonical form `{{name}}`.
  const names = [...String(key).matchAll(/{{\s*(\w+)\s*}}/g)].map((match) => `{{${match[1]}}}`)
  return [...new Set(names)]
}

/** Story 204 — RN6.5: for a system value the mandatory markers are the catalogue's params, never the ones the key would suggest. */
export const declaredPlaceholdersOf = (key, systemValues = NO_SYSTEM_VALUES) =>
  systemValues.has(key) ? systemValues.paramsOf(key).map((param) => `{{${param}}}`) : placeholdersOf(key)
